import React from 'react'
import { HeroClient } from './Component.client'
import type { Page } from '@/payload-types'

export const HeroBlock: React.FC<{
  hero: Page['hero']
}> = ({ hero }) => {
  if (!hero || hero.type !== 'carousel' || !hero.slides || hero.slides.length === 0) {
    return null
  }

  // Filter active slides
  const activeSlides = hero.slides.filter((slide) => slide.active !== false)

  if (activeSlides.length === 0) {
    return null
  }

  return <HeroClient slides={activeSlides} settings={hero.settings} />
}
